import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import "./veriCard.component.scss";

@Component({
    selector: "veri-card",
    template: require("./veriCard.component.html")
})
export class VeriCardComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() cardTitle: string;
    @Input() compactTitle: boolean;
    @Input() titleCount: number;
    @Input() greyBackground: boolean;
    @Input() loading: boolean;
    @Input() padding: boolean;
    @Input() collapsed: boolean;
    @Input() collapsable: boolean;
    @Input() icon: string;

    //@HostBinding("class.flat-transparent") @Input() flatTransparent: boolean;

    @ViewChild('titleContainer', { static: true }) titleContainer: ElementRef;
    @ViewChild('titleStart', { static: true }) titleStart: ElementRef;
    @ViewChild('titleEnd', { static: true }) titleEnd: ElementRef;
    @ViewChild('footer', { static: true }) footer: ElementRef;
    @ViewChild('actionFooter', { static: true }) actionFooter: ElementRef;

    constructor() { }

    ngOnInit(): void {}

    ngAfterViewInit() {    
        this.removeElementsIfEmpty();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.compactTitle == undefined) {
            this.compactTitle = true;
        }

        this.removeElementsIfEmpty();
    }

    toggleCollapsed(): void {
        if (this.collapsable) {
            this.collapsed = !this.collapsed;
        }
    }

    // ---

    private removeElementsIfEmpty(): void {
        if (!this.cardTitle && !this.titleStart?.nativeElement?.innerHTML && !this.titleEnd?.nativeElement?.innerHTML) {
            this.titleContainer.nativeElement.remove();
        }

        if (!this.footer?.nativeElement?.innerHTML) {
            this.footer.nativeElement.remove();
        }

        if (!this.actionFooter?.nativeElement?.innerHTML) {
            this.actionFooter.nativeElement.remove();
        }
    }
}
